import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'
import App from "./App";

 //Sobrescrevendo as funções do console em ambiente de produção
//if (process.env.NODE_ENV === 'production') {
//  console.log = console.error = console.warn = () => {};
//}

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		// Remover a tela de carregamento quando o React terminar de renderizar
		setTimeout(() => {
			if (typeof window.finishProgress === 'function') {
				window.finishProgress();
			}
		}, 100);
	}
);

// Service Worker DESABILITADO - estava causando problemas:
// 1. Cache persistente em aba anônima
// 2. Socket não funcionando
// 3. Mensagens em tempo real não chegando
// serviceworker.register()
serviceworker.unregister()